import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Repeat, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function Membership() {
  const [params] = useSearchParams();
  const joined = params.get("joined") === "1";

  const [form, setForm] = useState({ name: "", email: "", shipping_address: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const membership = await api.post("/membership/subscribe", form);
      const checkout = await api.post(
        `/membership/${membership.data.id}/checkout`,
      );
      // Stripe redirect, or local success page when Stripe is mocked.
      window.location.href = checkout.data.url;
    } catch (err) {
      setError(err.response?.data?.detail || "Could not sign up.");
      setSubmitting(false);
    }
  };

  if (joined) {
    return (
      <div className="mx-auto max-w-md py-16 text-center">
        <CheckCircle2 className="mx-auto text-fairway-600" size={48} />
        <h1 className="mt-3 text-2xl font-extrabold">You're all set!</h1>
        <p className="text-gray-600">
          Your refill membership is active. We'll ship your first refill pack
          within the year and email you before each renewal.
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-10 md:grid-cols-2">
      <div>
        <Repeat className="text-fairway-600" size={32} />
        <h1 className="mt-2 text-3xl font-extrabold">Refill Membership</h1>
        <p className="mt-2 text-gray-600">
          Got a First Aid Golf kit at an event? Keep it stocked year-round.
        </p>
        <p className="mt-4 text-4xl font-extrabold text-fairway-700">
          $14<span className="text-base font-medium text-gray-500">/year</span>
        </p>
        <ul className="mt-4 space-y-2">
          {[
            "One full refill pack shipped each year",
            "Renewal reminders by email",
            "Cancel anytime",
          ].map((t) => (
            <li key={t} className="flex items-center gap-2 text-sm text-gray-700">
              <CheckCircle2 size={16} className="text-fairway-600" />
              {t}
            </li>
          ))}
        </ul>
      </div>

      <form onSubmit={submit} className="card space-y-4 p-6">
        <h2 className="text-lg font-bold">Join the membership</h2>
        <div>
          <label className="label">Full name *</label>
          <input className="input" required value={form.name} onChange={set("name")} />
        </div>
        <div>
          <label className="label">Email *</label>
          <input type="email" className="input" required value={form.email} onChange={set("email")} />
        </div>
        <div>
          <label className="label">Shipping address *</label>
          <textarea className="input" rows="3" required value={form.shipping_address} onChange={set("shipping_address")} />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button className="btn-primary w-full" disabled={submitting}>
          {submitting ? "Starting checkout…" : "Sign Up & Pay — $14/year"}
        </button>
      </form>
    </div>
  );
}
